<template>
    <v-dialog
        v-model="showDialog"
        width="600"
    >
        <v-card>
            <v-form
                ref="form"
                @submit.prevent="submitForm"
            >
                <v-card-title style="background-color: #009688; color: white; word-wrap: normal;">
                    New Group
                </v-card-title>
                <v-card-text style="max-height: 70vh; overflow-y: scroll; background-color: #EDFFFB;">
                    <div style="background-color: white; border-radius: 20px; padding: 10px 10px 0  10px; margin-top: 25px">
                        <v-text-field
                            v-model.trim="MSUGRP_NAME"
                            label="Group Name"
                            :rules="[v=>!!v || 'This field is required']"
                        />
                    </div>
                </v-card-text>
                <v-card-actions style="background-color: #EDFFFB;">
                    <v-spacer />
                    <v-btn
                        outlined
                        class="white--text"
                        color="teal darken-1"
                        style="text-transform: none; width: 105px;"
                        @click="showDialog = false"
                    >
                        CLOSE
                    </v-btn>
                    <v-btn
                        color="teal darken-1 white--text"
                        class="white--text"
                        style="text-transform: none; width: 105px; font-weight: 600"
                        :loading="loading"
                        type="submit"
                    >
                        CREATE
                    </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
    props: ['show', 'notif'],
    data: ()=>({
        MSUGRP_NAME: null,
        loading: false
    }),
    computed: {
        ...mapGetters(['createMsuGroupData']),
        showDialog: {
            get() {
                return this.show
            },
            set() {
                this.$refs.form.reset()
                this.$emit('closeDialog')
            }
        }
    },
    watch: {
        createMsuGroupData(newVal) {
            if (newVal) {
                if (newVal.status === 201) {
                    this.notif.type = 'success'
                    this.notif.color = 'success'
                    this.notif.timeout = 5000
                    this.notif.msg = 'New group created.'
                    this.notif.show = true
                    this.showDialog = false
                    this.listMsuGroups()
                } else {
                    this.notif.type = 'error'
                    this.notif.color = 'error'
                    this.notif.timeout = 5000
                    this.notif.msg = newVal.state
                    this.notif.show = true
                }
            }
            this.loading = false
        }
    },
    methods: {
        ...mapActions(['createMsuGroup', 'listMsuGroups']),
        submitForm() {
            if (this.$refs && this.$refs.form && this.$refs.form.validate()) {
                this.loading = true
                this.createMsuGroup({ MSUGRP_NAME: this.MSUGRP_NAME })
            }
        }
    }
}
</script>
